import { createContext, useContext } from "react";

interface TableContextValue {
  isResizable: boolean;
}

export const TableContext = createContext<TableContextValue>({
  isResizable: true,
});

export function useTableContext() {
  return useContext(TableContext);
}
